import { useContainerMediaQuery } from '@infl-ts/util-block-width-context';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BadgesModalButton } from '../badges-progress';
import { ProgressBar } from '../progress-bar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Label = function Label(_ref) {
  var label = _ref.label,
      _ref$sx = _ref.sx,
      sx = _ref$sx === void 0 ? {} : _ref$sx;
  return /*#__PURE__*/_jsx(Typography, {
    variant: "buttonLarge",
    sx: sx,
    "data-element": "Typography",
    "data-component": "Label",
    "data-source-file": "index.tsx",
    children: label
  });
};

var AchievementsButton = function AchievementsButton(_ref2) {
  var label = _ref2.label,
      interactive = _ref2.interactive,
      _ref2$sx = _ref2.sx,
      sx = _ref2$sx === void 0 ? {} : _ref2$sx;

  var buttonLabel = /*#__PURE__*/_jsx(Label, {
    label: label,
    sx: sx
  });

  return interactive ? /*#__PURE__*/_jsx(BadgesModalButton, {
    disableTouchRipple: true,
    sx: {
      px: 0,
      textAlign: 'left',
      justifyContent: 'flex-start',
      '&:hover': {
        backgroundColor: 'initial',
        color: function color(t) {
          return t.palette.primary.dark;
        }
      }
    },
    children: buttonLabel
  }) : buttonLabel;
};

export var LevelProgress = function LevelProgress(_ref3) {
  var _nextLevel$earnedBadg, _nextLevel$requiredBa;

  var currentLevel = _ref3.currentLevel,
      nextLevel = _ref3.nextLevel,
      _ref3$isCurrentContac = _ref3.isCurrentContact,
      isCurrentContact = _ref3$isCurrentContac === void 0 ? false : _ref3$isCurrentContac;
  var isTabletOrDesktop = useContainerMediaQuery({
    minWidth: 'md'
  });
  var isNotLoaded = useContainerMediaQuery({
    maxWidth: 0
  });
  var earnedBadgeCount = (_nextLevel$earnedBadg = nextLevel === null || nextLevel === void 0 ? void 0 : nextLevel.earnedBadgesCount) !== null && _nextLevel$earnedBadg !== void 0 ? _nextLevel$earnedBadg : 0;
  var requiredBadgeCount = (_nextLevel$requiredBa = nextLevel === null || nextLevel === void 0 ? void 0 : nextLevel.requiredBadgesCount) !== null && _nextLevel$requiredBa !== void 0 ? _nextLevel$requiredBa : 0;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: 'flex',
      flexDirection: isTabletOrDesktop || isNotLoaded ? 'row' : 'column',
      justifyContent: 'space-between'
    },
    "data-element": "Box",
    "data-component": "LevelProgress",
    "data-source-file": "index.tsx",
    children: [/*#__PURE__*/_jsxs(Box, {
      sx: {
        mr: 4,
        display: 'flex',
        flexDirection: 'column'
      },
      "data-element": "Box",
      "data-component": "LevelProgress",
      "data-source-file": "index.tsx",
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "h4",
        "data-element": "Typography",
        "data-component": "LevelProgress",
        "data-source-file": "index.tsx",
        children: t('Level')
      }), /*#__PURE__*/_jsx(AchievementsButton, {
        label: currentLevel.name,
        interactive: isCurrentContact,
        "data-element": "AchievementsButton",
        "data-source-file": "index.tsx"
      })]
    }), nextLevel && isCurrentContact && /*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        flexDirection: 'column',
        width: 1,
        maxWidth: 350,
        mt: isTabletOrDesktop ? 0 : 3
      },
      children: [/*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          mb: 0.5
        },
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h4",
          sx: {
            pr: 1
          },
          children: t('Progress to next level:')
        }), /*#__PURE__*/_jsx(AchievementsButton, {
          label: nextLevel.level.name,
          interactive: isCurrentContact
        })]
      }), /*#__PURE__*/_jsx(ProgressBar, {
        size: "large",
        progress: requiredBadgeCount !== 0 ? Math.min(earnedBadgeCount, requiredBadgeCount) / requiredBadgeCount * 100 : 0
      }), requiredBadgeCount > 0 ? /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          mt: 0.5
        },
        children: [/*#__PURE__*/_jsxs(Typography, {
          variant: "caption",
          sx: {
            mr: 1
          },
          children: [earnedBadgeCount, " / ", requiredBadgeCount, " ", t('badges earned'), " -"]
        }), /*#__PURE__*/_jsx(AchievementsButton, {
          sx: {
            fontSize: function fontSize(t) {
              return t.typography.caption.fontSize;
            }
          },
          label: t("{{badgeCount}} more required", {
            badgeCount: Math.max(0, requiredBadgeCount - earnedBadgeCount)
          }),
          interactive: isCurrentContact
        })]
      }) : null]
    })]
  });
};